module.exports = __webpack_public_path__ + "static/img/succeed@2x.65a11cfb.png";